  export const socialLinks = {
    facebook: 'https://www.facebook.com/share/1AwVPeiBF6/',
    instagram: 'https://www.instagram.com/adelaide.samba.encontro',
  };
  
  export const sponsors = [
    {
      name: 'City of Port Adelaide Enfield',
      logo: '/assets/images/sponsors/city-of-pae-logo.png',
      url: 'https://www.cityofpae.sa.gov.au/',
    },
  ];

  export const organisers = [
  {
    name: 'Sasamba',
    logo: '/assets/images/sponsors/sasamba-logo.png',
    url: 'https://www.sasamba.com.au/',
  }, 
  ];
